<template>
  <div class="home">
    <div class="v-2-banners">
        <div class="container">
          <div class="row">
            <div class="col">
                <div class="item sports">
                    <div class="border-animate"></div>
                    <img src="@/assets/images/common/new/sport.png" class="figure">
                    <div class="bottom">
                      <div class="title" :class="{ 'animate': animate }"><span v-for="item in 'SPOR'"> {{ item }}</span></div>
                      <div class="desc" :class="{ 'animate': animate }"><span v-for="item in 'BAHİSLERİ'"> {{ item }}</span></div>
                      <small>SENİN BAHİSİN, SENİN HEYECANIN!</small>
                      <router-link to="/sportsbook" :class="{ 'animate': animate }" class="button primary">ŞİMDİ OYNA!</router-link>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="item casino">
                    <div class="border-animate"></div>
                    <img src="@/assets/images/common/new/casino.png" class="figure">
                    <div class="bottom">
                      <div class="title" :class="{ 'animate': animate }"><span v-for="item in 'CANLI'"> {{ item }}</span></div>
                      <div class="desc" :class="{ 'animate': animate }"><span v-for="item in 'CASINO'"> {{ item }}</span></div>
                      <small>SENİN BAHİSİN, SENİN HEYECANIN!</small>
                      <router-link to="casino" :class="{ 'animate': animate }" class="button primary">ŞİMDİ OYNA!</router-link>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="item slot">
                    <div class="border-animate"></div>
                    <img src="@/assets/images/common/new/slot.gif" class="figure">
                    <div class="bottom">
                      <div class="title" :class="{ 'animate': animate }"><span v-for="item in 'SLOT'"> {{ item }}</span></div>
                      <div class="desc" :class="{ 'animate': animate }"><span v-for="item in 'OYUNLAR'"> {{ item }}</span></div>
                      <small>SENİN BAHİSİN, SENİN HEYECANIN!</small>
                      <router-link to="slot" :class="{ 'animate': animate }" class="button primary">ŞİMDİ OYNA!</router-link>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="item poker">
                    <div class="border-animate"></div>
                    <img src="@/assets/images/common/new/poker.png" class="figure">
                    <div class="bottom">
                      <div class="title" :class="{ 'animate': animate }"><span v-for="item in 'POKER'"> {{ item }}</span></div>
                      <div class="desc" :class="{ 'animate': animate }"><span v-for="item in 'CANLI'"> {{ item }}</span></div>
                      <small>SENİN BAHİSİN, SENİN HEYECANIN!</small>
                      <router-link to="poker" :class="{ 'animate': animate }" class="button primary">ŞİMDİ OYNA!</router-link>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    <div class="container">
      <div class="row">
          <!-- <Jackpot style="width: 100%; padding: 10px 0px 20px 0;" v-if="egt_show"/> -->
      </div>
    </div>
      <div class="container">
        <div class="home-casino-temp">
          <div class="title">
            <div class="icon">
              <svg x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <g> <g> <path d="M320.931,199.65c-12.096-12.322-24.894-23.893-36.035-32.583c-17.462-13.618-24.614-15.363-28.896-15.363    s-11.434,1.745-28.896,15.363c-11.141,8.69-23.939,20.262-36.035,32.583c-18.243,18.581-48.847,53.076-48.847,75.313    c0,36.597,28.854,66.37,65.049,66.37c14.035,0,28.581-4.648,38.062-12.808v31.771c0,5.236,4.245,9.481,9.482,9.481    s9.482-4.245,9.482-9.481v-31.771c11.852,8.16,25.213,12.808,39.248,12.808c36.194,0,65.938-29.773,65.938-66.37    C369.482,252.727,339.174,218.231,320.931,199.65z M304.137,322.37c-16.497,0-31.444-8.574-39.987-22.935    c-1.71-2.873-4.806-4.634-8.149-4.634c-3.344,0-6.44,1.762-8.149,4.634c-8.543,14.361-23.491,22.935-39.987,22.935    c-25.738,0-46.678-21.266-46.678-47.407c0-8.593,12.873-30.539,41.632-60.201c25.715-26.521,47.275-42.005,53.183-43.977    c5.907,1.972,27.468,17.456,53.183,43.977c28.759,29.662,41.632,51.609,41.632,60.201    C350.815,301.104,329.875,322.37,304.137,322.37z"/> </g> </g> <g> <g> <path d="M256,0C114.841,0,0,114.84,0,256s114.841,256,256,256s256-114.84,256-256S397.159,0,256,0z M461.255,137.544    l-69.918,31.074c-12.42-19.169-28.786-35.535-47.955-47.954l31.074-69.919C410.414,71.579,440.421,101.586,461.255,137.544z     M398.222,256c0,78.421-63.801,142.222-142.222,142.222S113.778,334.421,113.778,256S177.579,113.778,256,113.778    S398.222,177.579,398.222,256z M256,18.963c36.355,0,70.82,8.236,101.64,22.926l-30.825,69.356    c-21.389-10.507-45.419-16.43-70.815-16.43c-25.396,0-49.426,5.924-70.815,16.43L154.36,41.889    C185.18,27.199,219.645,18.963,256,18.963z M137.544,50.745l31.074,69.919c-19.169,12.419-35.535,28.785-47.955,47.953    l-69.918-31.074C71.579,101.586,101.586,71.579,137.544,50.745z M18.963,256c0-36.357,8.236-70.82,22.926-101.641l69.356,30.826    c-10.507,21.389-16.43,45.419-16.43,70.815c0,25.396,5.924,49.426,16.43,70.815l-69.356,30.826    C27.199,326.82,18.963,292.357,18.963,256z M50.745,374.456l69.918-31.074c12.42,19.169,28.786,35.535,47.955,47.953    l-31.074,69.919C101.586,440.421,71.579,410.414,50.745,374.456z M256,493.037c-36.355,0-70.82-8.236-101.64-22.926l30.825-69.356    c21.389,10.507,45.419,16.43,70.815,16.43c25.396,0,49.426-5.924,70.815-16.43l30.825,69.356    C326.82,484.801,292.355,493.037,256,493.037z M374.456,461.255l-31.074-69.919c19.169-12.419,35.535-28.785,47.955-47.954    l69.918,31.074C440.421,410.414,410.414,440.421,374.456,461.255z M400.755,326.815c10.507-21.389,16.43-45.419,16.43-70.815    c0-25.396-5.924-49.426-16.43-70.815l69.356-30.826c14.69,30.822,22.926,65.285,22.926,101.641s-8.236,70.82-22.926,101.641    L400.755,326.815z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
            </div>
            <div class="text">
              <h1>Canlı Casino</h1>
              <p>Canlı oynayın, heyecanı yaşayın !</p>
            </div>
          </div>
          <div class="games">
            <div class="row row-wrap">
                <Game
                  @click.native="open(item.p, item.id,'Casino')"
                  :key="name" 
                  v-for="(item, name, index) in casinoGames" class="col col-2">
                  <template slot="img">
                      <img :src="$store.state.main.cdn_url + client_id + '/assets/images/special/v2/' + item.img + '?5'"/>
                      <div class="game-play-btn">
                        <svg viewBox="0 0 24 24" fill="none"> <path fill-rule="evenodd" clip-rule="evenodd" d="M3 5.49686C3 3.17662 5.52116 1.73465 7.52106 2.91106L18.5764 9.41423C20.5484 10.5742 20.5484 13.4259 18.5764 14.5858L7.52106 21.089C5.52116 22.2654 3 20.8234 3 18.5032V5.49686Z" fill="#323232"/> </svg>
                      </div>
                  </template>
                  <template slot="play">
                    <button type="button" @click="runGame({id: item.id, device: isMobile})" class="button primary">Hemen Oyna</button>
                  </template>
                </Game>
            </div>
          </div>
          <Modal class="casino-login-modal" @modalStatus="loginModal = $event" :isVisible="loginModal && !$auth()">
            <template slot="content">
                <UserLogin/>
            </template>
          </Modal>
        </div>
      </div>
      <div class="home-under-s" style="height:150px" v-if="!_.isEmpty(lastWinners)">
        <div class="container">
        <h1>SON KAZANANLAR</h1>
          <swiper v-if="!isLoading" :options="swiperOptionWinners">
            <swiper-slide  v-for="(item,key) in lastWinners" :key="key">
              <router-link :to="'/' + item.url">
                <img width="100%" :src="$store.state.main.cdn_url + item.image"/>
              </router-link>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <!--
      <div class="container">
        <div class="home-casino-temp">
          <div class="title">
            <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 420.751 420.751" style="enable-background:new 0 0 420.751 420.751;" xml:space="preserve"> <g> <g> <path d="M374.431,130.094c5.233,0,9.969-2.12,13.399-5.55c3.43-3.43,5.55-8.166,5.55-13.399c0-10.465-8.484-18.944-18.949-18.944    s-18.949,8.484-18.949,18.944C355.482,121.61,363.965,130.094,374.431,130.094z"/> <path d="M99.092,328.642c-9.8,0-17.741,7.946-17.741,17.741c0,9.795,7.946,17.741,17.741,17.741s17.741-7.941,17.741-17.741    C116.833,336.584,108.892,328.642,99.092,328.642z"/> <path d="M365.962,140.385v152.873h16.937V140.385c-2.56,1.29-5.407,2.084-8.468,2.084    C371.369,142.469,368.522,141.67,365.962,140.385z"/> <path d="M245.74,328.642c-9.8,0-17.741,7.946-17.741,17.741c0,9.795,7.941,17.741,17.741,17.741s17.741-7.941,17.741-17.741    C263.48,336.584,255.539,328.642,245.74,328.642z"/> <path d="M332.037,11.658H9.907C4.434,11.658,0,16.092,0,21.565v387.528h341.949V21.565    C341.944,16.092,337.51,11.658,332.037,11.658z M231.511,35.82c8.238,0,14.915,6.676,14.915,14.915s-6.677,14.915-14.915,14.915    c-8.238,0-14.915-6.676-14.915-14.915C216.597,42.496,223.273,35.82,231.511,35.82z M172.416,24.064    c14.725,0,26.665,11.94,26.665,26.665c0,14.725-11.94,26.665-26.665,26.665c-14.725,0-26.665-11.94-26.665-26.665    C145.751,36.004,157.691,24.064,172.416,24.064z M113.321,35.82c8.238,0,14.915,6.676,14.915,14.915s-6.677,14.915-14.915,14.915    c-8.238,0-14.915-6.676-14.915-14.915C98.412,42.496,105.088,35.82,113.321,35.82z M99.092,374.41    c-15.478,0-28.022-12.544-28.022-28.022s12.549-28.022,28.022-28.022c15.478,0,28.022,12.549,28.022,28.022    C127.114,361.861,114.57,374.41,99.092,374.41z M172.416,374.41c-15.478,0-28.022-12.544-28.022-28.022    s12.544-28.022,28.022-28.022c15.478,0,28.022,12.549,28.022,28.022C200.438,361.861,187.894,374.41,172.416,374.41z     M245.74,374.41c-15.478,0-28.022-12.544-28.022-28.022s12.544-28.022,28.022-28.022c15.478,0,28.022,12.549,28.022,28.022    C273.761,361.861,261.217,374.41,245.74,374.41z M320.323,280.407H24.509V90.987h295.813V280.407z"/> <path d="M172.416,328.642c-9.8,0-17.741,7.946-17.741,17.741c0,9.795,7.946,17.741,17.741,17.741    c9.8,0,17.741-7.941,17.741-17.741C190.157,336.584,182.216,328.642,172.416,328.642z"/> <path d="M113.326,108.006h-0.005H36.618v155.121h76.708V108.006z M103.434,172.104c-0.01,0-0.015,0-0.02,0    c0,0.107,0.02,0.195,0.02,0.302c0,18.186-27.192,24.827-16.246,50.714H57.718c-3.722-23.219,28.667-35.164,30.853-47.8    c-3.195,1.244-6.359,2.381-11.069,2.381c-9.651,0-10.593-4.721-23.634-5.478v9.175h-7.363v-20.7h7.363v0.113    c13.041,0.763,13.983,5.478,23.634,5.478c10.491,0,13.292-5.596,25.933-5.596V172.104z"/> <path d="M381.348,303.278h-28.437v78.812h28.437c21.765,0,39.404-17.643,39.404-39.404    C420.756,320.922,403.113,303.278,381.348,303.278z"/> <path d="M303.324,108.006h-0.005h-76.703v155.121h76.708V108.006z M293.432,172.104c-0.01,0-0.015,0-0.02,0    c0,0.107,0.02,0.195,0.02,0.302c0,18.186-27.192,24.827-16.246,50.714h-29.471c-3.722-23.219,28.667-35.164,30.853-47.8    c-3.195,1.244-6.359,2.381-11.069,2.381c-9.651,0-10.593-4.721-23.634-5.478v9.175h-7.363v-20.7h7.363v0.113    c13.041,0.763,13.988,5.478,23.634,5.478c10.491,0,13.292-5.596,25.933-5.596V172.104z"/> <path d="M208.323,108.006h-76.708v155.121h76.708V108.006z M198.436,172.104c-0.01,0-0.015,0-0.021,0    c0,0.107,0.021,0.195,0.021,0.302c0,18.186-27.192,24.827-16.246,50.714h-29.471c-3.722-23.219,28.667-35.164,30.853-47.8    c-3.195,1.244-6.359,2.381-11.069,2.381c-9.646,0-10.593-4.721-23.634-5.478v9.175h-7.363v-20.7h7.363v0.113    c13.041,0.763,13.988,5.478,23.634,5.478c10.491,0,13.292-5.596,25.933-5.596V172.104z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
            </div>
            <div class="text">
              <h1>Slot Oyunlar</h1>
              <p>HD Slot Oyunları ile her zaman kazanın !</p>
            </div>
          </div>
          <div class="games">
            <div class="row row-wrap">
                <Game
                  @click.native="open(item.p, item.id,'Slot')" 
                  :key="name" 
                  v-for="(item, name, index) in slotGames" class="col col-2">
                  <template slot="img">
                      <img :src="$store.state.main.cdn_url + client_id + '/assets/images/special/v2/' + item.img + '?5'"/>
                      <div class="game-play-btn">
                        <svg viewBox="0 0 24 24" fill="none"> <path fill-rule="evenodd" clip-rule="evenodd" d="M3 5.49686C3 3.17662 5.52116 1.73465 7.52106 2.91106L18.5764 9.41423C20.5484 10.5742 20.5484 13.4259 18.5764 14.5858L7.52106 21.089C5.52116 22.2654 3 20.8234 3 18.5032V5.49686Z" fill="#323232"/> </svg>
                      </div>
                  </template>
                  <template slot="play">
                    <button type="button" @click="runGame({id: item.id, device: isMobile})" class="button primary">Hemen Oyna</button>
                  </template>
                </Game>
            </div>
          </div>
        </div>
      </div>-->
    <div class="home-partners" v-if="!_.isEmpty(partners)">
        <div class="container">
          <div class="row">
            <div class="col" v-for="(item,key) in partners" :key="key">
                <img width="100%" :src="$store.state.main.cdn_url + item.image"/>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
  import { ENV_CURRENT_DOMAIN, ENV_CDN_URL } from '../../plugins/replaces'
  import Jackpot from '../Common/Jackpot'
  import Game from '../Casino/Game'
  import UserLogin from '../../views/Auth/Login'
  export default {
    components:{
      Game,
      UserLogin,
      Jackpot
    },
    data() {
      return {
        eventSlider:[],
        partners:[],
        lastWinners:[],
        loginModal: false,
        isLoading: false,
        animate:true,
        swiperOption: {
					lazy: true,
					speed: 1500,
          slidesPerView: 3,
          autoplay: {
            delay: 2000,
					},
          // effect: 'fade',
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        swiperOptionWinners: {
					lazy: true,
					speed: 1500,
          slidesPerView: 4,
          autoplay: {
            delay: 2000,
					},
          // effect: 'fade',
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        casinoGames:[
          {
            title: 'Lightning Dice',
            provider: 'Evolution Gaming',
            p: 'evolutiongaming',
            id: 726019,
            img: 'lightning-dice.jpg?v.9285165256129'
          },
          {
            title: 'Lightning Roulette',
            provider: 'Evolution Gaming',
            p: 'evolutiongaming',
            id: 726019,
            img: 'lightning-roulette.jpg?v.9285165256129'
          },
          {
            title: 'Monopoly Live',
            provider: 'Evolution Gaming',
            p: 'evolutiongaming',
            id: 726019,
            img: 'monopoly-live.jpg?v.9285165256129'
          },
          {
            title: 'Deal or No Deal',
            provider: 'Evolution Gaming',
            p: 'evolutiongaming',
            id: 726019,
            img: 'dealornodeal.jpg?v.9285165256129'
          },
          {
            title: '',
            provider: 'Evolution Gaming',
            p: 'evolutiongaming',
            id: 726019,
            img: 'crazytime.jpg?v.9285165256129'
          },
          {
            title: '',
            provider: '',
            p: 'pragmaticplay',
            id: 69809,
            img: 'candyland.jpg?v.9285165256129'
          },
        ],
        slotGames:[
          {
            title: 'Sweet Bonanza',
            provider: 'Pragmaticplay',
            p: 'pragmaticplay',
            id: 727593,
            img: 'sweetbonanza.jpg?v.9285165256129'
          },
          {
            title: 'Gates of Olympus',
            provider: 'Pragmaticplay',
            p: 'pragmaticplay',
            id: 727590,
            img: 'gatesofolympus.jpg?v.9285165256129'
          },
          {
            title: 'Cowboy Coins',
            provider: 'Pragmaticplay',
            p: 'pragmaticplay',
            id: 727673,
            img: 'cowboycoins.jpg?v.9285165256129'
          },
          {
            title: 'Starlight Princess',
            provider: 'Pragmaticplay',
            p: 'pragmaticplay',
            id: 727592,
            img: 'starlight.jpg?v.9285165256129'
          },
          {
            title: 'Bigger Bass Bonanza',
            provider: 'Pragmaticplay',
            p: 'pragmaticplay',
            id: 727709,
            img: 'biggerbassbonanza.jpg?v.9285165256129'
          },
          {
            title: 'The Dog House',
            provider: 'Pragmaticplay',
            p: 'pragmaticplay',
            id: 727609,
            img: 'thedoghouse.jpg?v.9285165256129'
          },
        ]
      }
    },
    created(){
      this.fetchData();
      setTimeout(() => {
        this.animate = false
      }, 2000);
      setInterval(() => {
        this.animate = true;
          setTimeout(() => {
            this.animate = false
          }, 2000);
      }, 5000);
    },
    methods:{
      fetchData: function() {
          if(this.isMobile){
            this.swiperOption.slidesPerView = 1
            this.swiperOptionWinners.slidesPerView = 2;
          }
          this.isLoading = true,
          this.$store.dispatch('getBanner', ['home', 'both', 'bottom'])
          .then(response =>{
            this.eventSlider = _.sortBy(response.data, ['sort'])
            this.isLoading = false;
          });
          this.$store.dispatch('getBanner', ['home', 'both', 'single'])
          .then(response =>{
            this.partners = _.sortBy(response.data, ['sort'])
            this.isLoading = false;
          });
          this.$store.dispatch('getBanner', ['home', 'both', 'left'])
          .then(response =>{
            this.lastWinners = _.sortBy(response.data, ['sort'])
            this.isLoading = false;
          });
      },
      open(provider, id, route){
        let routeData = this.$router.resolve({ name: route, params: { provider: provider, category : 'all' }, query: { game_id: id, mobile: this.isMobile }});
        if(!this.$auth()){
          this.loginModal = true
          return false;
        }else{
          window.location.href = routeData.href;
        }
      },
    },
    computed:{
      egt_show(){
        if(this.locale == 'TR' && this.user && this.user.balance > 0){
          return true
        }else{
          return false
        }
      },
      locale(){
          return this.$store.getters.getLocale;
      },
      client_id(){
        return process.env.VUE_APP_CLIENT_ID
      },
      user(){
        return this.$user();
      },
      cdn_url(){
       return this.$store.getters['getCdnUrl']
      },
      current_domain(){
        return ENV_CURRENT_DOMAIN;
      },
      specialTemplate(){
          return this.$store.getters.getSpecialTemplate;
      }
    },
  }
</script>